import { useEffect, useMemo, useRef, useContext } from "react";
import styles from "./changelog.module.css";
import { CardOne } from "../../../components/cards/cardOne";
import { CardTwo } from "../../../components/cards/cardTwo";
import { GoBackButton } from "../../../components/buttons/goBack";
import { navigationGamepadLoop } from "../../../utilities/utilities";
import { themeContext } from "../../../context/theme";
import { CHANGELOG } from "./changelogData";

export const Changelog = ({ setShowChangelog, game }) => {
  const { theme } = useContext(themeContext);
  const changelogRef = useRef();
  const gamepadLoopState = useMemo(() => ({ run: true }), []);

  const keyDownHandler = (event) => {
    if (event.stopPropagation) {
      event.stopPropagation();
      if (event.key !== "Escape") return;
    }
    if (event.key === "ArrowDown") {
      changelogRef.current?.scrollBy({ top: 50 });
    } else if (event.key === "ArrowUp") {
      changelogRef.current?.scrollBy({ top: -50 });
    } else if (event.key === "Back" || event.key === "Escape") {
      game.sounds.clickSound.play();
      gamepadLoopState.run = false;
      setShowChangelog(false);
    }
  };

  useEffect(() => {
    if (gamepadLoopState.run) {
      navigationGamepadLoop(game, keyDownHandler, gamepadLoopState);
    }
  }, []);

  useEffect(() => {
    changelogRef.current?.focus();
    return () => { gamepadLoopState.run = false; };
  }, []);

  const categoryOrder = ["feature", "fix"];
  const categoryLabel = { feature: "NEW / IMPROVED", fix: "FIX" };
  const categoryClass = { feature: styles["category-new"], fix: styles["category-fix"] };

  const groupByType = (changes) => {
    const grouped = {};
    for (const change of changes) {
      const type = change.type === "improvement" ? "feature" : change.type;
      if (!grouped[type]) grouped[type] = [];
      grouped[type].push(change.text);
    }
    return grouped;
  };

  return (
    <CardOne
      customTag="section"
      attributes={{
        className: styles["changelog-section"],
        onKeyDown: keyDownHandler,
        tabIndex: -1,
        ref: changelogRef,
      }}
    >
      <GoBackButton onClickHandler={() => setShowChangelog(false)} game={game} />
      <div className={styles["changelog"]}>
        <h1 className={styles["changelog-heading"]}>Changelog</h1>
        {CHANGELOG.map((release, idx) => {
          const grouped = groupByType(release.changes);
          return (
            <CardTwo key={release.version} customClass={styles["release"]}>
              <div className={styles["release-header"]}>
                <div className={styles["release-title"]}>
                  <span className={styles["version"] + " " + styles["version-" + theme]}>
                    v{release.version},
                  </span>
                  <span className={styles["date"]}>{release.date}</span>
                </div>
                <span className={styles["release-index"]}>{CHANGELOG.length - idx}</span>
              </div>
              {categoryOrder.map((type) =>
                grouped[type] ? (
                  <div key={type} className={styles["category-section"]}>
                    <h3 className={styles["category-heading"] + " " + (categoryClass[type] || "")}>
                      {categoryLabel[type]}
                    </h3>
                    <ul className={styles["changes-list"]}>
                      {grouped[type].map((text, i) => (
                        <li key={i} className={styles["change-item"]}>
                          <span className={styles["change-text"]}>• {text}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                ) : null
              )}
            </CardTwo>
          );
        })}
      </div>
    </CardOne>
  );
};
